import React from 'react';
export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning';
}
function Badge({
  className = '',
  variant = 'default',
  ...props
}: BadgeProps) {
  let variantClasses = '';
  switch (variant) {
    case 'default':
      variantClasses = 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80';
      break;
    case 'secondary':
      variantClasses = 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80';
      break;
    case 'destructive':
      variantClasses = 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80';
      break;
    case 'outline':
      variantClasses = 'text-foreground';
      break;
    case 'success':
      variantClasses = 'border-transparent bg-green-500/15 text-green-500 hover:bg-green-500/25';
      break;
    case 'warning':
      variantClasses = 'border-transparent bg-yellow-500/15 text-yellow-500 hover:bg-yellow-500/25';
      break;
  }
  return <div className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ${variantClasses} ${className}`} {...props} data-id="element-135" />;
}
export { Badge };